export const MAX_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export function clampPageSize(pageSize) {
  const n = Number(pageSize);
  if (!Number.isFinite(n) || n < 1) return 10;
  return Math.min(n, MAX_PAGE_SIZE);
}

export function getPaginatedResults(data) {
  if (!data || typeof data !== 'object') return [];
  return Array.isArray(data.results) ? data.results : [];
}

/** Read list items from a paginated wrapper, plain array, or named key (e.g. `permissions`). */
export function getPaginatedOrKeyedResults(data, alternateResultsKey) {
  if (Array.isArray(data)) return data;
  if (!data || typeof data !== 'object') return [];
  if (Array.isArray(data.results)) return data.results;
  if (alternateResultsKey && Array.isArray(data[alternateResultsKey])) {
    return data[alternateResultsKey];
  }
  return [];
}

export function getPaginatedMeta(data, fallbackPageSize = 10) {
  if (!data || typeof data !== 'object') {
    return {
      results: [],
      count: 0,
      page_index: 1,
      page_size: clampPageSize(fallbackPageSize),
    };
  }
  return {
    results: Array.isArray(data.results) ? data.results : [],
    count: data.count != null ? data.count : 0,
    page_index: data.page_index != null ? data.page_index : 1,
    page_size: data.page_size != null ? clampPageSize(data.page_size) : clampPageSize(fallbackPageSize),
  };
}

/**
 * Page through a list API that returns axios-style { data: { count, results, ... } }.
 * @param {(page: number, pageSize: number) => Promise<{data: object}>} fetchPage
 * @param {{ pageSize?: number }} [options]
 * @returns {Promise<Array>}
 */
export async function fetchAllPages(fetchPage, { pageSize = MAX_PAGE_SIZE } = {}) {
  const size = clampPageSize(pageSize);
  const allItems = [];
  let page = 1;
  let totalCount = null;

  while (totalCount === null || allItems.length < totalCount) {
    const response = await fetchPage(page, size);
    const body = response && response.data ? response.data : {};
    const { count, results } = body;
    totalCount = count != null ? count : 0;
    const pageResults = Array.isArray(results) ? results : [];
    allItems.push(...pageResults);
    if (pageResults.length === 0) break;
    page += 1;
  }

  return allItems;
}
